import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { formatApiError } from "../lib/auth";
import { Toaster, toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim() });
            setDone(true);
            toast.success("Check je inbox");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div data-testid="forgot-password-page" className="min-h-[80vh] grid place-items-center px-6 py-12 bg-zinc-50">
            <Toaster />
            <div className="w-full max-w-md card p-8">
                <p className="label-tiny">Wachtwoord vergeten</p>
                <h1 className="font-display text-4xl mt-2">Geen probleem.</h1>
                {done ? (
                    <div className="mt-6 border border-emerald-200 bg-emerald-50 p-5 text-sm text-emerald-900">
                        Als <strong>{email}</strong> bij ons gekend is, ontvang je binnen enkele minuten een mail met een reset-link. Check ook je spam folder.
                    </div>
                ) : (
                    <>
                        <p className="text-sm text-zinc-500 mt-2">Vul je email in. We sturen je een link om een nieuw wachtwoord in te stellen.</p>
                        <form onSubmit={onSubmit} className="mt-8 space-y-4">
                            <div>
                                <label className="label-tiny block mb-2">E-mail</label>
                                <input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-flat" placeholder="je@mail.be" />
                            </div>
                            <button data-testid="forgot-submit" type="submit" disabled={submitting} className="btn-primary w-full">
                                {submitting ? "Versturen…" : "Stuur reset-link"}
                            </button>
                        </form>
                    </>
                )}
                <p className="text-sm text-zinc-500 mt-6 text-center">
                    <Link data-testid="forgot-back-login" to="/login" className="underline">← Terug naar inloggen</Link>
                </p>
            </div>
        </div>
    );
}
